<template>
  <div class="container" @click="flagOn">
    <section id="editContent" class="columnContainer amenity">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.tv_channel_guide}}</h1>
        <SetController
          :locale="locale" />
        <ChannelList
          :locale="locale"
          :list="list"
          :genre="genre"
          :lang="lang" />
      </div>
      <div class="innerSide"><div class="sideBox">
        <ChannelFilter
          :locale="locale"
          :genre="genre"
          :lang="lang" />
      </div></div>
    </section>
  </div>
</template>

<script>
import TVCHANNEL from '@/common/tvchannel'
import ChannelFilter from '@/components/Tv/Filter.vue'
import ChannelList from '@/components/Tv/List.vue'
import SetController from '@/components/Tv/SetController.vue'

export default {
  name: 'Tv',
  props: [
    'locale'
  ],
  components: {
    ChannelFilter,
    ChannelList,
    SetController
  },
  computed: {
    genre () {
      return TVCHANNEL.genre
    },
    lang () {
      return TVCHANNEL.lang
    },
    list () {
      return this.$store.getters['tv/chList']
    },
    chLang () {
      return this.$store.state.service.locale.default
    }
  },
  created () {
    this.$store.commit('onLoading', true)
    this.$store.dispatch('tv/getChannel')
    this.$store.dispatch('tv/getSetting').then(() => {
      this.$store.commit('onLoading', false)
    })
  },
  mounted () {
  },
  data () {
    return {
      dirtyFlag: false
    }
  },
  methods: {
    flagOn () {
      this.dirtyFlag = true
    }
  }
}
</script>

<style lang="scss" scoped>
#editContent.columnContainer .innerSide {
  width: 300px;
}
#editContent.columnContainer .sideBox {
  margin-left: 0;
  padding-left: 0;
}
</style>
